import { defineComponent as _defineComponent } from 'vue'
import SimulationResults from '@/components/calculator/results/SimulationResults.vue';
import {ProductType} from '@/commons/enums/ProductType';
import {SimulationResultConfig} from '@/components/calculator/results/SimulationResultConfig';
import {getCurrentInstance, onMounted, onUnmounted, ref, Ref} from 'vue';
import {UserInputPanelElementEnum} from '@/components/calculator/results/userInputPanel/UserInputPanelElementEnum';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import FpChipRadio from '@/components/inputs/FpChipRadio.vue';
import LoanPeriodSlider from '@/components/calculator/LoanPeriodSlider.vue';
import ReferenceRatePanel from '@/components/calculator/results/userInputPanel/ReferenceRatePanel.vue';
import {debouncedAtInput} from '@/services/utils/BasicUtils';
import EnvironmentService from '@/env/EnvironmentService';
import {currencyDictionary, installmentTypeDictionary} from '@/modules/multiForm/shared/MultiformDictionaries';
import useOfferSorting from '@/components/calculator/results/OfferSorting';
import MortgageSimulationAvailableProductsTabs
  from '@/components/calculator/mortgage/MortgageSimulationAvailableProductsTabs.vue';
import {useOnboarding} from '@/modules/onboarding/useOnboarding';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {I18N_Calculator_Results} from '@/services/enumTranslator/I18N_CALCULATOR/I18N_Calculator_Results';
import {useCalculatorFormRules} from '@/components/calculator/useCalculatorFormRules';
import {TourName} from '@/modules/onboarding/tour/models/TourOptions';


export default /*#__PURE__*/_defineComponent({
  __name: 'MortgageSimulationResults',
  setup(__props) {

const instance = getCurrentInstance();
const onboarding = useOnboarding(TourName.MORTGAGE_CALCULATOR);
const {availableProductsItems,} = useOfferSorting();
const store = useSimulationStore();
const {loanAmountRules, hypothecValueRules,} = useCalculatorFormRules();
const simulationId = instance?.proxy.$route.params.simulationId;
const {debtToIncomeRules,} = useCalculatorFormRules();

store.init(ProductType.MORTGAGE, simulationId);

const simulationResultConfig: Ref<SimulationResultConfig> = ref({
  fullscreen: !!instance?.proxy.$vuetify.breakpoint.mdAndDown,
  userInputPanels: [] as UserInputPanelElementEnum[],
});

const getLabel = (I18NDictContent: keyof I18N_Calculator_Results['useMortgageSimulationResults']): string => {
  return I18NGetter().useMortgageSimulationResults[I18NDictContent];
};
const useMortgageSimulationResultsEnum = I18NGetter().useMortgageSimulationResults;
const monthsSuffix = I18NGetter().useMortgageSimulationResults.MONTHS_SUFFIX;
// To będzie do wykasowania po wprowadzeniu simV2
const onLoanPeriodInMonthsChange = debouncedAtInput(($event: number) => {
  if (EnvironmentService.Environment.isBackendSimV2) {
        store.userInput!.loanPeriod = $event;
  } else {
        store.userInput!.loanPeriod = Math.round($event / 12);
        store.userInput!.loanPeriodInMonths = $event;
  }
});
const onSliderInput = debouncedAtInput(($event: number) => {
  if (!EnvironmentService.Environment.isBackendSimV2) {
        store.userInput!.loanPeriodInMonths = $event ? $event * 12 : null;
  }
});

onMounted(() => onboarding.start());
onUnmounted(() => onboarding.stop());

return { __sfc: true,instance, onboarding, availableProductsItems, store, loanAmountRules, hypothecValueRules, simulationId, debtToIncomeRules, simulationResultConfig, getLabel, useMortgageSimulationResultsEnum, monthsSuffix, onLoanPeriodInMonthsChange, onSliderInput, SimulationResults, FpChipRadio, LoanPeriodSlider, ReferenceRatePanel, currencyDictionary, installmentTypeDictionary, MortgageSimulationAvailableProductsTabs }
}

})